import type { CellarCoolingModel } from './cellar-coolings.types';
import type { TemperatureTrend } from './common.types';
import type { FobModel } from './fob.types';
import type { RemoteCoolerModel } from './remote-coolers.types';

export interface CellarModel {
  id: string;
  name: string;
  description: string;
  status: CellarStatusType;
  minTemperature: number | null;
  maxTemperature: number | null;
  trend?: TemperatureTrend[];
  type: CellarType;
  createdAt?: string;
  updatedAt?: string;
  cellarCoolings: CellarCoolingModel[];
  remoteCoolers: RemoteCoolerModel[];
  fobs: FobModel[];
  energySavingSystem?: EnergySavingSystemType[] | null;
  gasCopExpiryDate?: string | null;
}

export interface ListCellarsResponse {
  result: ListCellarModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAllCellarsResponse {
  allCellarsResult: ListCellarModel[];
}

export interface CreateCellarParams {
  venueId: string | null;
  name: string | null;
  description: string | null;
  status: CellarStatusType;
  type: CellarType;
  energySavingSystem?: EnergySavingSystemType[] | null;
  gasCopExpiryDate?: string | null;
}

export interface UpdateCellarParams extends CreateCellarParams {
  cellarId: string | null;
}

export interface DeleteCellarParams {
  cellarId: string;
}

export enum CellarStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum CellarType {
  TEMPERATURE_CONTROLLED = 'Temperature Controlled',
  TEMPERATURE_CONTROLLED_WITH_CASK = 'Temperature Controlled With Cask',
  AMBIENT = 'Ambient',
  UNDER_COUNTER = 'Under Counter',
  KEG_COOLER = 'Keg Cooler'
}

export type CellarsSortingFields = 'name' | 'type' | 'description' | 'status';

export type ListCellarModel = Pick<
  CellarModel,
  'id' | 'name' | 'type' | 'description' | 'status' | 'energySavingSystem' | 'gasCopExpiryDate'
>;

export enum EnergySavingSystemType {
  PROVAGO_ENERSAVE = 'Provago Enersave',
  TECHNIK2_CELLAR_MANAGER = 'Technik2 Cellar Manager',
  TECHNIK2_OCTOPUS_CELLAR_COOLER = 'Technik2 Octopus Cellar Cooler',
  BEERTECH_SMARTCELLAR = 'Beertech SmartCellar',
  INNSERVE_INNSAVE = 'Innserve InnSave',
  J_E_HALL_AMBIENT_BEER_COOLER = 'J&E Hall Ambient Beer Cooler',
  BREWFITT_ENERGY_SAVER_PLUGS = 'Brewfitt Energy Saver Plugs',
  GENERIC_TIMER_PLUGS = 'Generic Timer Plugs',
  OTHER_SYSTEM = 'Other System'
}
